import React, { Component } from 'react'
import { Utils } from '../utils/utils.js'
import PropTypes from 'prop-types'
import API from '../utils/API'
import moment from 'moment'
import { strings } from '../utils/translations.js'
import styles from './VRExpirationTag.module.scss'
import { Modal } from 'antd'
import classnames from 'classnames'
import history from '../utils/routes/history'

export const EXPIRATION_DAYS_SHOW_WARNING = 29

export default class VRExpirationTag extends Component
{
    constructor(props)
    {
        super(props)
        
        this.state =
        {
            myVirtualRemote: null
        }
    }
    
    componentDidMount()
    {
        this.setMyVirtualRemote()
    }
    componentDidUpdate(prevProps, prevState)
    {
        if (prevProps.door != this.props.door)
            this.setMyVirtualRemote()
    }
    
    render()
    {
        if (this.state.myVirtualRemote == null)
			return <div/>
		
		let {
            isExpired,
            daysTilExpiration,
            hoursTilExpiration,
            minutesTilExpiration,
            isCancelled,
            isTrial,
            userPays,
            paymentAdded,
            isPastDue
        } = this.getIsExpired()
        
        let shouldShowView = ((isExpired || daysTilExpiration <= EXPIRATION_DAYS_SHOW_WARNING) &&
                              (isCancelled || (isTrial && !paymentAdded))) || isPastDue
        
		if (!shouldShowView)
			return <div/>
		
        const isBig = this.props.bigTag
        const isBigger = this.props.biggerTag
		
		return (
			<div
				className={classnames(styles.expirationView,
                        isBig ? styles.expirationViewBig : null,
                        isBigger ? styles.expirationViewBigger : null,
                        (this.props.containerStyle != null) ? this.props.containerStyle : null
                    )}
				onClick={(e) => this.onPress(e, userPays, this.state.myVirtualRemote.delegatedUser, isPastDue)}
			>
                <div className={styles.expirationViewTop}>
    				<img
    					src={require('../../img/icons/warning_bold.svg').default}
    					className={classnames(styles.expirationViewIcon,
                                isBigger ? styles.expirationViewIconBigger : null)}
    				/>
    				<div className={classnames(styles.expirationViewText,
                                    isBigger ? styles.expirationViewTextBigText : null)}>
                        <span className={styles.expirationViewTextOrange}>
    						{
                                isPastDue ?
                                strings('pastDue')
                                :
                                (
                                    isExpired ? strings('renewSubscription') :
                                            (isBig ? `${strings('expiresLong')} ` : `${strings('expires')}: `)
                                )
                            }
    					</span>
    					{
    						!isExpired && !isPastDue &&
    						(
    							(daysTilExpiration > 0) ?
    							`${daysTilExpiration} ${(daysTilExpiration > 1) ? strings('days') : strings('day')}`
    							:
    							(
    								(hoursTilExpiration > 0) ?
    								`${hoursTilExpiration} ${(hoursTilExpiration > 1 || hoursTilExpiration === 0) ? strings('hours') : strings('hour')}`
                                    :
                                    `${minutesTilExpiration} ${(minutesTilExpiration > 1 || minutesTilExpiration === 0) ? strings('minutes') : strings('minute')}`
    							)
    						)
    					}
    				</div>
                </div>
                
                {
                    isBig &&
                    <div className={classnames(styles.expirationViewSubtitle,
                                    isBigger ? styles.expirationViewSubtitleBigText : null)}>
                        {
                            isPastDue ?
                            strings('pastDueInfo')
                            :
                            `${strings('renewSubscriptionLong')}.`
                        }
                    </div>
                }
			</div>
		)
    }
    
    onPress(e, userPays, delegatedUser, isPastDue)
    {
        e.stopPropagation()
        
        if (isPastDue)
        {
            if (this.props.onPress != null)
                this.props.onPress()
            else
            {
                Modal.confirm(
                {
                    title: strings('pastDue'),
                    content: <div>{strings('pastDueInfo')}</div>,
                    okText: strings('goToRenew'),
                    cancelText: strings('cancel'),
                    onOk: () => this.openBuyRemotesScreen(),
                    centered: true,
                    autoFocusButton: null,
                    closable: true
                })
            }
        }
        else if (userPays)
        {
            if (this.props.onPress != null)
                this.props.onPress()
            else
            {
                Modal.confirm(
                {
                    title: strings('renewSubscription'),
                    content: <div>{strings('renewSubscriptionText')}</div>,
                    okText: strings('goToRenew'),
                    cancelText: strings('cancel'),
                    onOk: () => this.openBuyRemotesScreen(),
                    centered: true,
                    autoFocusButton: null,
                    closable: true
                })
            }
        }
        else
        {
            Modal.warning(
            {
                title: strings('renewSubscriptionContactTitle'),
                content: (
                    <div>
                         {strings('renewSubscriptionContact1')} <b>{`${delegatedUser?.name} ${delegatedUser?.lastName}`}</b> {strings('renewSubscriptionContact2')}
                    </div>
                ),
                centered: true,
                autoFocusButton: null
            })
        }
    }
    
    getMyVirtualRemote()
	{
        return this.props.door.assignedVirtualRemote
	}
	setMyVirtualRemote()
	{
		let myVirtualRemote = this.getMyVirtualRemote()
        if (myVirtualRemote)
        {
            this.setState({ myVirtualRemote })
        }
	}
    
    openBuyRemotesScreen()
    {
        history.push("/extra-virtual-remotes?house_id="+this.props.door.houseId)
    }
    
    getIsExpired()
    {
        let vr = this.state.myVirtualRemote
        
        if (vr == null)
            return null
        
        let expiredObj = Utils.getVRisExpired(vr)
        
        if (this.props.onIsExpiredChanged != null)
            this.props.onIsExpiredChanged(expiredObj)
        
        return expiredObj
    }
}


VRExpirationTag.propTypes =
{
    door: PropTypes.any.isRequired,
    containerStyle: PropTypes.any,
    onPress: PropTypes.func,
    bigTag: PropTypes.bool,
    biggerTag: PropTypes.bool,
    onIsExpiredChanged: PropTypes.func
}